import React from 'react'
import Classes from '../Dashboard.module.css'
import { useNavigate } from 'react-router-dom'

export default function TrialStrip({ remainingDays }) {
    const navigateTo = useNavigate();

  return (
    <>
      <div className={Classes.trialStrip}>
        <h5>
          Your free trial has {remainingDays} {remainingDays === 1 ? 'day' : 'days'} remaining
        </h5>
        <button>
           <a onClick={()=>navigateTo('/upgrade')}>
            <h5>Select a plan</h5>
            </a>
        </button>
      </div>
    </>
  )
}